import { Aviso } from './../../model/aviso';
import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ServicioGeneral } from "../../_services/servicio-general.service";
import { ActivatedRoute, Data, Router, UrlSegmentGroup } from "@angular/router";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Observable } from 'rxjs';
import { AvisosService } from 'src/app/_services/avisos.service';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
//import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';
import { ConfirmDeleteDialogComponent } from 'src/app/modal/confirm-delete/confirm-delete-dialog.component';
import { ConfirmUpdateDialogComponent } from 'src/app/modal/confirmar-update/confirm-update-dialog/confirm-update-dialog.component';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';

export interface DataModel {
  menuListado: string;
}

@Component({
  selector: 'app-listado-avisos',
  templateUrl: './listado-avisos.component.html',
  styleUrls: ['./listado-avisos.component.css']
})
export class ListadoAvisosComponent extends UnsubscribeOnDestroy implements OnInit {
  displayedColumns: string[] = ['titulo', 'cuerpo','estado','acciones'];


  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  get totalAvisos(): number { return this.dataSource?.data?.length || 0; }
  get avisosMostrados(): number { return this.dataSource?.filteredData?.length ?? this.totalAvisos; }
  constructor(
    private formBuilder: UntypedFormBuilder,
    private avisosService: AvisosService,
    public dialog: MatDialog,
    private router: Router,
    
    
    ) { super(); }
    
    formVisible: UntypedFormGroup = new UntypedFormGroup({
      visible: new UntypedFormControl("")
    })
  
    formFechaCierre = new UntypedFormGroup({
      fecha: new UntypedFormControl(""),
      hora: new UntypedFormControl(""),
    })
  
    formFechaApertura = new UntypedFormGroup({
      fecha: new UntypedFormControl(""),
      hora: new UntypedFormControl(""),
    })

  myForm: UntypedFormGroup;
  menuListado: any = [];
  menuOption: String;
  avisos: Array<any> = [];
  dataSource = new MatTableDataSource<Aviso>();

  public buildForm() {
    this.myForm = this.formBuilder.group({
      opcionesmenu: [null],
    });
  }

  ngOnInit(): void {

    this.getAvisos();
  }

  async getAvisos() {
    await this.avisosService.getListAvisos()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
        this.avisos = data.Aviso;
        this.avisos=this.avisos.filter(aviso=> aviso.fechaBaja==null);
        this.dataSource = new MatTableDataSource(this.avisos)
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      error: (err) => {
      }
    })
  }

  updateAvisos(id: String): Observable<any> {
    return this.avisosService.updateAvisos(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
      },
      error: (err) => {
      }
    })
  }

  updateCierreAvisos(id: String) {
    const formData = new FormData();
    formData.append('fecha', `${this.formFechaCierre.value.fecha}T${this.formFechaCierre.value.hora}:00`);
    this.avisosService.updateCierreAviso(id, formData)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {

      },
      error: (err) => {
      }
    });
  }

  updateAperturaAvisos(id: String) {
    const formData = new FormData();
    formData.append('fecha', `${this.formFechaApertura.value.fecha}T${this.formFechaApertura.value.hora}:00`);
    this.avisosService.updateAperturaAviso(id, formData)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
      
      },
      error: (err) => {
      }
    });
  }

  openDeleteDialog(aviso: Aviso){
    const ref = this.dialog.open(ConfirmDeleteDialogComponent, {
      data: {
        title: 'Eliminar aviso',
        message: `¿Seguro que quieres eliminar el aviso «${aviso.titulo}»? Esta acción no se puede deshacer.`,
        confirmLabel: 'Eliminar'
      },
      panelClass: 'gu-dialog-panel'
    });
    return ref.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((ok) => {
        if (!ok) return;
        this.borrarAviso(aviso.id);
        this.reloadToMenuOption();
      });
  }
  borrarAviso(id: number | String) {
    this.avisosService.deleteAviso(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
      },
      error: (err) => {
      }
    });  }

  openDialog(aviso: Aviso): void {
    
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.autoFocus = true;
    dialogConfig.width = '25vw';
    dialogConfig.minWidth = '500px';
    dialogConfig.data = aviso;
    const dialogRef = this.dialog.open(EditAvisoDialog, dialogConfig)

  }

  scrollTop() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  reloadToMenuOption() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.scrollTop()
    this.router.navigate(['/admin'], { queryParams: { action: 13 } });

  }
}

@Component({
  selector: "dialog-editAviso-dialog",
  templateUrl: "./dialog-editAviso-dialog.html",
  styleUrls: ['./dialog-editAviso-dialog.css']
})
export class EditAvisoDialog extends UnsubscribeOnDestroy implements OnInit {

  constructor(public dialogRef: MatDialogRef<EditAvisoDialog>
    , @Inject(MAT_DIALOG_DATA) public aviso: any,
    private router: Router, 
    public dialog: MatDialog,
    private avisosService: AvisosService,
  ) { super(); }

  isVisible = this.aviso.visible;
  fechaAperturaIncompletaWarning: boolean = false;
  fechaCierreIncompletaWarning: boolean = false;
  formData:FormData;

  formUpdate: UntypedFormGroup = new UntypedFormGroup({
    titulo: new UntypedFormControl(""),
    cuerpo: new UntypedFormControl(""),
    documento: new UntypedFormControl(""),
    fechaApertura: new UntypedFormControl(""),
    horaApertura: new UntypedFormControl(""),
    fechaCierre: new UntypedFormControl(""),
    horaCierre: new UntypedFormControl(""),
  })

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  updateApertura(id: number) {

  }
  updateCierre(id: number) {
  }

  updateVisibility(ob: MatCheckboxChange) {
    this.isVisible = ob.checked;
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.formUpdate.patchValue({
        documento: file
      });
    }
  }
  borrarAviso(id: Number) {
    throw new Error('Method not implemented.');
  }

  async openDialog(): Promise<Data> {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.autoFocus = true;
    dialogConfig.width = '25vw';
    dialogConfig.minWidth = '500px';
    dialogConfig.data={titulo: "actualización"}

    this.formData=this.comprobarDatos()

    if (!this.fechaAperturaIncompletaWarning && !this.fechaCierreIncompletaWarning) {
      const dialogRef = this.dialog.open(ConfirmUpdateDialogComponent, dialogConfig);
      return dialogRef.afterClosed()
        .pipe(takeUntil(this.destroy$))
        .subscribe(result => {
        if (result.result == 'Confirmar') {
          this.updateAviso(this.aviso.id)
        }
      })
    } else {
      return null;
    }

  }

  updateAviso(id: String) {

    if (!this.fechaAperturaIncompletaWarning && !this.fechaCierreIncompletaWarning) {
      this.avisosService.updateAviso(id, this.formData)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
        next: (data) => {
          this.reloadToMenuOption();
          this.onNoClick();
        },
        error: (err) => {
          //this.update = false;
        }
      });
    }
  }

  private comprobarDatos() {

    const formData = new FormData();
    if (this.formUpdate.value.titulo != "") {
      formData.append('titulo', this.formUpdate.value.titulo);
    } else {
      formData.append('titulo', this.aviso.titulo);
    }
    if (this.formUpdate.value.cuerpo != "") {
      formData.append('cuerpo', this.formUpdate.value.cuerpo);
    } else {
      formData.append('cuerpo', this.aviso.cuerpo);
    }
    if (this.formUpdate.value.documento != "") {
      formData.append('documento', this.formUpdate.value.documento);
    }

    this.comprobarFechaApertura(formData);

    this.comprobarFechaCierrre(formData);

    formData.append('visible', this.isVisible);
    return formData;
  }


  private comprobarFechaCierrre(formData: FormData) {
    var datestr;
    if (this.formUpdate.value.fechaCierre != "" && this.formUpdate.value.horaCierre != "") {
      formData.append('fechaCierre', `${this.formUpdate.value.fechaCierre}T${this.formUpdate.value.horaCierre}:00`);
      this.fechaCierreIncompletaWarning = false;
    } else if ((this.formUpdate.value.fechaCierre != "" && this.formUpdate.value.horaCierre == "") || (this.formUpdate.value.fechaCierre == "" && this.formUpdate.value.horaCierre != "")) {
      this.fechaCierreIncompletaWarning = true;
    } else if (this.aviso.fechaCierre) {
      datestr = (new Date(this.aviso.fechaCierre[0], this.aviso.fechaCierre[1], this.aviso.fechaCierre[2], this.aviso.fechaCierre[3], this.aviso.fechaCierre[4]).toISOString());
      this.fechaCierreIncompletaWarning = false;
      formData.append('fechaCierre', `${datestr}`);
    } else {
      this.fechaCierreIncompletaWarning = false;
      formData.append('fechaCierre', '');
    }
  }

  private comprobarFechaApertura(formData: FormData) {
    var datestr;
    if (this.formUpdate.value.fechaApertura != "" && this.formUpdate.value.horaApertura != "") {
      formData.append('fechaApertura', `${this.formUpdate.value.fechaApertura}T${this.formUpdate.value.horaApertura}:00`);
      this.fechaAperturaIncompletaWarning = false;
    } else if ((this.formUpdate.value.fechaApertura != "" && this.formUpdate.value.horaApertura == "") || (this.formUpdate.value.fechaApertura == "" && this.formUpdate.value.horaApertura != "")) {
      this.fechaAperturaIncompletaWarning = true;
    } else if (this.aviso.fechaApertura) {
      datestr = (new Date(this.aviso.fechaApertura[0], this.aviso.fechaApertura[1], this.aviso.fechaApertura[2], this.aviso.fechaApertura[3], this.aviso.fechaApertura[4]).toISOString());
      this.fechaAperturaIncompletaWarning = false;
      formData.append('fechaApertura', `${datestr}`);
    } else {
      this.fechaAperturaIncompletaWarning = false;
      formData.append('fechaApertura', '');
    }
  }

  scrollTop() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  reloadToMenuOption() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.scrollTop()
    this.router.navigate(['/admin'], { queryParams: { action: 13 } });

  }
}
